/**
 * Pure access control functions for organisation settings visibility.
 *
 * Extracted from OrganizationSwitcherV2 so they can be tested
 * independently with property-based tests.
 */

export interface ActiveOrganizationMember {
  role: string
}

export interface ActiveOrganization {
  member: ActiveOrganizationMember
}

export interface User {
  role: string
}

/**
 * Determines whether the "Organisation Settings" menu item should be visible.
 *
 * Visible when:
 * - The user's platform role is "admin", OR
 * - The user's organisation member role is "admin" or "owner"
 */
export function canAccessOrgSettings(
  activeOrganization: ActiveOrganization | null | undefined,
  user: User | null | undefined
): boolean {
  const isPlatformAdmin = user?.role === "admin"
  const isOrgAdminOrOwner =
    activeOrganization?.member.role === "admin" ||
    activeOrganization?.member.role === "owner"
  return isPlatformAdmin || isOrgAdminOrOwner
}
